import React from 'react'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import BaseTemplate from 'components/templates/BaseTemplate'
import LikeListNavbar from 'components/molecules/LikeListNavbar'
import Thumbnails from 'components/organisms/Thumbnails'

const Likes = ({
  kind,
  data,
  isLoading,
}) => (
  <BaseTemplate noBreadcrumb useNewHeader>
    <div id="Likes">
      <LikeListNavbar />
      <Thumbnails
        kind={kind}
        data={data}
        isLoading={isLoading}
      />
    </div>
  </BaseTemplate>
)

Likes.propTypes = {
  kind: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
}

Likes.defaultProps = {
  kind: 'schools',
  data: [],
  isLoading: false,
}

export { Likes }
export default branch({
  kind: ['serverProps', 'kind'],
  data: ['serverProps', 'data'],
  isLoading: ['commonProps', 'isLoading'],
}, Likes)
